export const AUTOMATION_PRESETS = [
  {
    id: 'welcome',
    icon: '👋',
    name: 'ข้อความต้อนรับ',
    description: 'ส่งข้อความทักทายทันทีที่ลูกค้าเริ่มสนทนา',
    eventLabel: 'Conversation Created',
    actionLabel: 'Send Message',
    rule: {
      name: 'ข้อความต้อนรับ',
      description: 'ส่งข้อความต้อนรับอัตโนมัติ',
      event_name: 'conversation_created',
      active: true,
      conditions: [
        {
          attribute_key: 'status',
          filter_operator: 'equal_to',
          values: ['open'],
          query_operator: null,
          custom_attribute_type: '',
        },
      ],
      actions: [
        {
          action_name: 'send_message',
          action_params: [
            'สวัสดีครับ/ค่ะ 👋 ยินดีต้อนรับ มีอะไรให้ช่วยได้บ้างครับ?',
          ],
        },
      ],
    },
  },
  {
    id: 'price-inquiry',
    icon: '💰',
    name: 'ลูกค้าถามราคา',
    description: 'ตอบอัตโนมัติเมื่อลูกค้าถามเรื่องราคาหรือค่าบริการ',
    eventLabel: 'Message Created',
    actionLabel: 'Send Message',
    rule: {
      name: 'ลูกค้าถามราคา',
      description: 'ตอบเมื่อข้อความมีคำว่าราคา/เท่าไหร่',
      event_name: 'message_created',
      active: true,
      conditions: [
        {
          attribute_key: 'content',
          filter_operator: 'contains',
          values: ['ราคา', 'เท่าไหร่', 'ค่าบริการ'],
          query_operator: null,
          custom_attribute_type: '',
        },
      ],
      actions: [
        {
          action_name: 'send_message',
          action_params: [
            'ขอบคุณที่สนใจค่ะ ✨ ราคาของเราเริ่มต้นที่... (แก้ไขข้อความนี้)',
          ],
        },
      ],
    },
  },
  {
    id: 'idle-resolve',
    icon: '⏰',
    name: 'ปิดสนทนาอัตโนมัติ',
    description: 'ปิดสนทนาที่ไม่มีกิจกรรมนานกว่า 24 ชั่วโมง',
    eventLabel: 'Conversation Idle',
    actionLabel: 'Resolve Conversation',
    rule: {
      name: 'ปิดสนทนาอัตโนมัติหลัง 24 ชม.',
      description: 'ปิดสนทนาที่ idle เกิน 24 ชั่วโมง',
      event_name: 'conversation_idle',
      active: true,
      conditions: [
        {
          attribute_key: 'last_activity_at',
          filter_operator: 'greater_than',
          values: ['1440'],
          query_operator: null,
          custom_attribute_type: '',
        },
      ],
      actions: [
        {
          action_name: 'resolve_conversation',
          action_params: [],
        },
      ],
    },
  },
  {
    id: 'idle-reassign-ai',
    icon: '🤖',
    name: 'คืนให้ AI หลัง idle',
    description: 'ส่งกลับให้ AI agent หลังไม่มีกิจกรรม 1 ชั่วโมง',
    eventLabel: 'Conversation Idle',
    actionLabel: 'Assign Agent',
    rule: {
      name: 'คืนสนทนาให้ AI หลัง idle',
      description: 'Re-assign กลับให้ AI เมื่อไม่มีกิจกรรม 1 ชม.',
      event_name: 'conversation_idle',
      active: true,
      conditions: [
        {
          attribute_key: 'last_activity_at',
          filter_operator: 'greater_than',
          values: ['60'],
          query_operator: null,
          custom_attribute_type: '',
        },
      ],
      actions: [
        {
          action_name: 'assign_agent',
          action_params: [],
        },
      ],
    },
  },
  {
    id: 'label-new',
    icon: '🏷️',
    name: 'ติด Label ลูกค้าใหม่',
    description: 'ติด label "new-customer" ทุกครั้งที่มีสนทนาใหม่',
    eventLabel: 'Conversation Created',
    actionLabel: 'Add Label',
    rule: {
      name: 'ติด Label ลูกค้าใหม่',
      description: 'เพิ่ม label new-customer อัตโนมัติ',
      event_name: 'conversation_created',
      active: true,
      conditions: [
        {
          attribute_key: 'status',
          filter_operator: 'equal_to',
          values: ['open'],
          query_operator: null,
          custom_attribute_type: '',
        },
      ],
      actions: [
        {
          action_name: 'add_label',
          action_params: ['new-customer'],
        },
      ],
    },
  },
  {
    id: 'csat',
    icon: '⭐',
    name: 'ขอบคุณหลังปิดงาน',
    description: 'ส่งข้อความขอบคุณและขอ feedback เมื่อปิดสนทนา',
    eventLabel: 'Conversation Updated',
    actionLabel: 'Send Message',
    rule: {
      name: 'ขอบคุณหลังปิดสนทนา',
      description: 'ส่งข้อความขอบคุณเมื่อ resolve',
      event_name: 'conversation_updated',
      active: true,
      conditions: [
        {
          attribute_key: 'status',
          filter_operator: 'equal_to',
          values: ['resolved'],
          query_operator: null,
          custom_attribute_type: '',
        },
      ],
      actions: [
        {
          action_name: 'send_message',
          action_params: [
            'ขอบคุณที่ใช้บริการนะครับ/ค่ะ 🙏 หากมีอะไรเพิ่มเติมกลับมาคุยได้เลยครับ',
          ],
        },
      ],
    },
  },
];
